import { ShopifyProductMatchMapping } from '@domain/connection/models/ConnectionSettings';
import { suggestTargetForSource } from '@domain/connection/models/ShopifyMatchPreview';
import ImportPreview from '@features/connections/setup/ImportPreview';
import MatchFields from '@features/connections/setup/MatchFields';
import { useProductPreview } from '@features/connections/setup/productPreviewContext';
import { SHOPIFY_PRODUCT_SOURCE_FIELDS } from '@shared/connection/shopify/constants/shopifyProductFields';

interface ProductsStepProps {
  mapping: ShopifyProductMatchMapping;
  onMappingChange: (mapping: ShopifyProductMatchMapping) => void;
  targetOptions: { value: string; label: string }[];
}

const ProductsStep = ({ mapping, onMappingChange, targetOptions }: ProductsStepProps) => {
  const preview = useProductPreview();
  if (!preview) return null;

  return (
    <>
      <MatchFields
        marketplaceLabel="Shopify"
        description="We identify each unique product by linking a Shopify field to a JustStock product field."
        sourceFields={SHOPIFY_PRODUCT_SOURCE_FIELDS}
        mapping={mapping}
        targetOptions={targetOptions}
        onSourceChange={sourceField => {
          onMappingChange({
            sourceField,
            targetField: suggestTargetForSource(sourceField, mapping.targetField),
          });
        }}
        onTargetChange={targetField => onMappingChange({ ...mapping, targetField })}
      />
      <ImportPreview
        marketplaceLabel="Shopify"
        sourceFields={SHOPIFY_PRODUCT_SOURCE_FIELDS}
        sourceField={mapping.sourceField}
        products={preview.products}
        matches={preview.matches}
        duplicateValues={preview.duplicateValues}
        loading={preview.loading}
        error={preview.error}
        hasMore={!preview.showNothingToImport && preview.hasMore}
        onLoadMore={preview.loadMore}
      />
    </>
  );
};

export default ProductsStep;
